/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 18:04 23.04.2023
 * @ Description: conte a rebourt
 */


import "./index.css";
import React, {useState,useRef,useEffect} from "react";
import GamePageManager from "../../utils/GamePageManager";

export default function GameCountDown() {
    const contentRef=useRef();
    const count=useRef(3);
    const className=useRef("CountAnimation");
    const [content,setContent]=useState(count.current.toString());


    function wait(milSec){
        return new Promise(resolve => {
            setTimeout(resolve, milSec);
        });
    }


    async function timoutFunction(){
        if(count.current>0){
            setContent(count.current.toString());
        }
        else if(count.current==0){
            className.current+=" GO";
            setContent("GO !!");
        }
        else{
            GamePageManager.changePage("GameSentenceShower");
            return;
        }
        count.current--;
        await wait(750);
        timoutFunction();
    }

    useEffect(()=>{
        // reload animation
        contentRef.current.className=""; 
        void contentRef.current.offsetWidth;
        contentRef.current.className=className.current;
    },[content]);

    useEffect(()=>{
        if(count.current==3)timoutFunction();
    },[])


    return (
        <div className="GamePage GameCountDown">
            <h1 className="" ref={contentRef}>{content}</h1>
        </div>
    );
}
